
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lifecycle-studio/templates",
      function () {
        return require("private-next-pages/lifecycle-studio/templates.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lifecycle-studio/templates"])
      });
    }
  